








































import * as _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

import sortable from '@/components/Sortable.vue'

setNewSortOrder = (collection, item, sortorder) ->
  collection[item.dataset.order].sortorder = sortorder
  collection[item.dataset.order]


export default
  name: 'StatisticsAdministration'
  data: () ->
    age_ranges: null

  directives:
    'sortable': sortable

  methods:
    addRange: () ->
      @age_ranges.value.push ['','']

    deleteRange: (idx) ->
      @age_ranges.value.splice idx, 1

    reorderRanges: (new_index, old_index)->
      console.log new_index, old_index

    saveRanges: () ->
      @$store.dispatch 'updateConfig', @age_ranges

  created: () ->
    if !@are_loaded.resources then await @$store.dispatch 'getServices'
    if !@are_loaded.configs then await @$store.dispatch 'getConfigs'

    c = @configs.getEmbed 'config', (embed) ->
          embed.key == 'age_ranges'
    @age_ranges = _.cloneDeep c

  mounted: () ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ()->
    componentHandler.downgradeElements @$el

  computed: {
    mapGetters([
        'isLoaded'
    ])...
    mapState([
      'configs'
      'are_loaded'
    ])...
  }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/administration/Statistics.vue